import moment from 'moment'
import AXIOS_INSTANCE from './axiosInstance'

/**
 * Record one Weight vital (kg) for the patient on this encounter — the same POST /vital_signs
 * payload the doctor's Add Vitals modal sends. Errors are left to the caller.
 */
export const postWeightVital = async ({
  patientId,
  encounterId,
  kg
}: {
  patientId: string
  encounterId?: string
  kg: number
}) => {
  const now = moment()
  const payload = {
    data: {
      attributes: {
        vitals: [
          {
            captured_date: now.format('YYYY-MM-DD'),
            time: now.format('HH:mm'),
            unit: 'kg',
            value: kg,
            vital_type: 'Weight'
          }
        ]
      },
      relationships: {
        ...(encounterId && { encounter: { data: { id: encounterId, type: 'encounter' } } }),
        patient: { data: { id: patientId, type: 'patient' } }
      },
      type: 'vital_sign'
    }
  }
  const { data } = await AXIOS_INSTANCE.post('/vital_signs', payload, {
    headers: { 'Content-Type': 'application/vnd.api+json' }
  })
  return data
}
